import { render } from "./SavedMappings.vue?vue&type=template&id=31dd4ad4&scoped=true&ts=true"
import script from "./SavedMappings.vue?vue&type=script&lang=ts"
export * from "./SavedMappings.vue?vue&type=script&lang=ts"

import "./SavedMappings.vue?vue&type=style&index=0&id=31dd4ad4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31dd4ad4"]])

export default __exports__